var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"calculator-personal-gain-add-partner",on:{"click":function($event){return _vm.$emit('addPartner')}}},[_vm._v(" Пригласить партнера "),_c('span',{staticClass:"calculator-personal-gain-add-partner__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }